export default {
    /* GET_PRODUCTION_SITES
    ---------------------------------------------------------------
    */
    GET_PRODUCTION_SITES_REQUEST: (state) => {
        state.productionSitesLoading = true
    },
    GET_PRODUCTION_SITES_SUCCESS: (state, data) => {
        state.productionSites = data
        state.productionSitesLoading = false
    },
    GET_PRODUCTION_SITES_FAILURE: (state) => {
        state.productionSitesLoading = false
    },
    GET_USER_SQUADS_SUCCESS: (state, data) => {
        state.squads = data
    },
    GET_PRODUCTION_SITE_GROUPS_SUCCESS: (state, data) => {
        state.productionSiteGroups = data
    },
    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
}